import { Stack } from '@backyard-ui/core'

import styles from './ReviewSkeleton.styles'
import { ResumeSkeleton, HelpfulCommentsSkeleton } from './components'

const ReviewsSkeleton = () => (
  <Stack direction="column" spacing="16">
    <div className={styles().resume()}>
      <ResumeSkeleton />
    </div>

    <div className={styles().wrapper()}>
      <HelpfulCommentsSkeleton />
    </div>
  </Stack>
)

export default ReviewsSkeleton
